<div class="tabs-container">
  <ion-row>
    <ion-col size="12">
      <div>

        <mat-tab-group #tabGroup class="pr-10" (selectedTabChange)="tabTypeChanged($event)"
          *ngIf="getTabName !=='ExitReport'">

          <mat-tab label="myResigntion"
            *ngIf="!(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  person
                </span>My Resignation</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="teamResigntion"
            *ngIf="(((checkAuthority =='HOD_AND_MANAGER_AND_HR')||checkAuthority =='MANAGER_AND_HR') &&
        loggedInUserRole !== 'Employee')||(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  group
                </span>Team Resignation</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="deptResigntion"
            *ngIf="(((checkAuthority =='HOD_AND_HR'&& loggedInUserRole=='HOD')||checkAuthority =='HOD_AND_MANAGER_AND_HR'&& loggedInUserRole!=='Manager' )&&
        loggedInUserRole !== 'Employee')&&!(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  ads_click
                </span>Dept Resignation</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="termination"
            *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  ads_click
                </span>Submit Termination</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="termination"
            *ngIf="!['HR Admin', 'Admin', 'Super Admin', 'PHI Admin', 'MD','Employee'].includes(loggedInUserRole)">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">ads_click</span>Submit Termination
              </span>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
        <!-- ------------------------------------------------------------------------Exit Report Tab------------------------------------------------------ -->
        <mat-tab-group #tabGroup class="pr-10" (selectedTabChange)="tabTypeChanged($event)"
          *ngIf="getTabName=='ExitReport'">

          <mat-tab label="myResigntion"
            *ngIf="!(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  person
                </span>My Resignation Report</span>
            </ng-template>
          </mat-tab>{{checkAuthority}}
          <mat-tab label="teamResigntion"
            *ngIf="(((checkAuthority =='HOD_AND_MANAGER_AND_HR')||checkAuthority =='MANAGER_AND_HR') &&
loggedInUserRole !== 'Employee')||(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  group
                </span>Team Report</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="deptResigntion"
            *ngIf="(((checkAuthority =='HOD_AND_HR'&& loggedInUserRole=='HOD')||checkAuthority =='HOD_AND_MANAGER_AND_HR'&& loggedInUserRole!=='Manager' )&&
loggedInUserRole !== 'Employee')&&!(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  ads_click
                </span>Dept Report</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="termination"
            *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  ads_click
                </span> Termination Report</span>
            </ng-template>
          </mat-tab>

        </mat-tab-group>
        <!-- ------------------------------------------------------------------------Exit Report Tab------------------------------------------------------ -->
      </div>
    </ion-col>
  </ion-row>

  <div class="pt-10">
    <ion-row>





      <ion-col size="12"
        *ngIf="selectedTypeTabName=='myResigntion'&& !(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')&& selectedTypeTabName!=='termination'&& getTabName !=='ExitReport'">

        <button type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content mr-5"
          [style.background-color]="buttonColorName" (click)="employeeResignation(null,null)"
          [disabled]="terminatedUserId?.length > 0 || checkemployeeAcceptedRejected?.length > 0 ||chechsetupStatus"
          [style.opacity]="terminatedUserId?.length > 0 || checkemployeeAcceptedRejected?.length ||chechsetupStatus > 0? '0.5' : '1'">
          <span class="material-icons fs-20 mr-5">add</span>
          Add Resignation
        </button>

        <button type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content mr-5"
          [style.background-color]="buttonColorName" *ngIf="terminatedUserId?.length > 0"
          (click)="noDueForm(terminatedUserId[0])">
          <span class="material-icons fs-20 mr-5"></span>
          View No Due <Form></Form>
        </button>
        <button type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content mr-5"
          [style.background-color]="'red'" *ngIf="terminatedUserId?.length > 0"
          (click)="employeeTermintion(terminatedUserId[0],'notHR')">
          <span class="material-icons fs-20 mr-5">block</span>
          You are terminated
        </button>

      </ion-col>
    </ion-row>
  </div>

  <div class="cardBox b-20 p-10" *ngIf="selectedTypeTabName!=='termination'&&getTabName!=='ExitReport'">


    <ion-row>
      <ion-col size>
        <mat-form-field class="mat-height40 mat-input-style">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">

        </mat-form-field>
      </ion-col>
      <ion-col size="auto">
        <div class="phi-flex-wrap-center phi-gap-12">
          <label class="phi-flex phi-gap-6 phi-align-items-center">
            <ion-label class="fs-14 fs_12ForMobile font_regular black_color">Show</ion-label>
            <mat-form-field class="w70px mat-height40 mat-input-style">
              <mat-select placeholder="Select" placeholder="Select" (selectionChange)="DislaySelectedRecord($event)"
                [value]="25">
                <mat-option [value]="2">2</mat-option>
                <mat-option [value]="25">25</mat-option>
                <mat-option [value]="50">50</mat-option>
                <mat-option [value]="75">75</mat-option>
                <mat-option [value]="100">100</mat-option>
              </mat-select>
            </mat-form-field>
            <ion-label class="fs-14 fs_12ForMobile font_regular black_color">entries</ion-label>
          </label>
          <div>
            <span class="icon-download fs-20 material-icons" (click)="exportToCSV()">download</span>
          </div>
        </div>
      </ion-col>


      <!-- <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
        <div class="d-flex justify-content-flex-end ">
          <div class="d-flex" style="margin-right: 15px; margin-top: 10px;">
            <span class="ml-5 mr-5 icon-download fs-20 material-icons" (click)="exportToCSV()">download</span>
          </div>
        </div>
      </ion-col> -->
    </ion-row>
    <div class="p-10">
      <ion-row>
        <ion-col size="12">
          <div class="table-container">
            <table>
              <thead>
                <tr>

                  <th *ngFor="let item of OfferAndAppointmentTableHeader"
                    class="fs-14 fs_12ForMobile font_bold cl-black" [ngStyle]="{ 'max-width': item.maxWidth }">
                    <div class="p-5 icon-style" [innerHTML]="item.label"></div>
                  </th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of listofFromData; let i = index">
                  <td [ngStyle]="getRowStyle(item)">{{ i + 1 }}</td>

                  <td [ngStyle]="getRowStyle(item)">{{ item.empName
                    }}</td>
                  <td [ngStyle]="getRowStyle(item)">{{
                    item.empDepartment }}</td>
                  <td [ngStyle]="getRowStyle(item)">{{ item.empBand
                    }}</td>
                  <td [ngStyle]="getRowStyle(item)">{{ item.empGrade
                    }}</td>
                  <td [ngStyle]="getRowStyle(item)">{{
                    item.empDesignation }}</td>
                  <td [ngStyle]="getRowStyle(item)">{{
                    item.resignDate }}</td>
                  <td [ngStyle]="getRowStyle(item)">{{
                    item.employmentType }}</td>
                  <td [ngStyle]="getRowStyle(item)">{{
                    item.noticePeriod }}</td>
                  <td [ngStyle]="getRowStyle(item)">

                    <!-- {{
                    item.lastWorkingDay | date: 'dd/MM/yyyy' }} -->

                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <input matInput [matDatepicker]="picker" [(ngModel)]="item.lastWorkingDay"
                        placeholder="Select date" (dateChange)="updatedComment(item)" [min]="todayDate" readonly />
                      <mat-datepicker-toggle matSuffix [for]="picker"
                        [disabled]="(loggedInUserRole !== 'HR Admin' && loggedInUserRole !== 'Admin' && loggedInUserRole !== 'Super Admin' && 
             loggedInUserRole !== 'PHP Admin' && loggedInUserRole !== 'MD')||(item.withdrawalReason !== null ||item?.approvalStatus !== 'PENDING')"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>



                  </td>
                  <td [ngStyle]="getRowStyle(item)">{{
                    item.resignReason }}</td>
                  <td [ngStyle]="getRowStyle(item)">
                    <!-- {{
                    item.resignReasonInDetails }} -->
                    <textarea rows="3" cols="32" class="edittextarea" [(ngModel)]="item.resignReasonInDetails"
                      maxlength="255" [ngModelOptions]="{ standalone: true }" readonly>
                      </textarea>
                  </td>
                  <td [ngStyle]="getRowStyle(item)">
                    {{
                    item.contactNo }}</td>
                  <td [ngStyle]="getRowStyle(item)">
                    {{
                    item.personalMailId }}</td>
                  <td *ngIf="canShowSecretReason()" [ngStyle]="getRowStyle(item)">
                    <!-- {{ item.secretReasonForHr }}
                       -->
                    <textarea rows="3" cols="32" class="edittextarea" [(ngModel)]="item.secretReasonForHr"
                      maxlength="255" [ngModelOptions]="{ standalone: true }" readonly>
                      </textarea>
                  </td>

                  <td *ngIf="canShowManagerCommentSection()" [ngStyle]="getRowStyle(item)">
                    <textarea rows="3" cols="32" class="edittextarea" [(ngModel)]="item.managerComment" maxlength="255"
                      [ngModelOptions]="{ standalone: true }" (focusout)="handleManagerFocusOut(item)"
                      [readonly]="isManagerCommentReadonly(item)" [ngStyle]="getRowStyle(item)">
                      </textarea>
                  </td>

                  <td *ngIf="canShowHodCommentSection()" [ngStyle]="getRowStyle(item)">
                    <textarea rows="3" cols="32" class="edittextarea" [(ngModel)]="item.hodComment" maxlength="255"
                      [ngModelOptions]="{ standalone: true }" (focusout)="handleHodFocusOut(item)"
                      [readonly]="isHodCommentReadonly(item)" [ngStyle]="getRowStyle(item)">
                      </textarea>
                  </td>

                  <td [ngStyle]="getRowStyle(item)">
                    <!-- {{
                    item.hrComment || '-' }} -->
                    <textarea rows="3" cols="32" class="edittextarea"
                      (focusout)="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD' && item.terminationFormId == null &&item.withdrawalReason== null) ? updatedComment(item) : null"
                      [(ngModel)]="item.hrComment" maxlength="255" [ngModelOptions]="{standalone: true}"
                      [readonly]=" !(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')||item.terminationFormId != null||item.withdrawalReason !== null"></textarea>
                  </td>
                  <td *ngIf="showTd" [ngStyle]="getRowStyle(item)">


                    <button class="status-btn" [ngClass]="{ 'yes': item.regretType === 'Yes' }"
                      (click)="item.regretType = 'Yes'; updatedData(item)"
                      [disabled]="item.terminationFormId != null ||item.withdrawalReason !== null||item?.approvalStatus!= 'PENDING' ">
                      Yes



                    </button>

                    <button class="status-btn" [ngClass]="{ 'no': item.regretType === 'No' }"
                      (click)="item.regretType = 'No'; updatedData(item)"
                      [disabled]="item.terminationFormId != null ||item.withdrawalReason !== null||item?.approvalStatus!= 'PENDING' ">
                      No
                    </button>

                    <input type="hidden" [(ngModel)]="item.regretType" />

                  </td>

                  <td *ngIf="excludedRoles.includes(loggedInUserRole)" [ngStyle]="getRowStyle(item)">
                    <button class="status-btn" [ngClass]="{ 
      'yes': item.regretType === 'Yes', 
      'no': item.regretType === 'No' 
    }" *ngIf="item.regretType!==null && item.regretType!==''">
                      {{ item.regretType }}
                    </button>


                  </td>

                  <!-- </mat-form-field> -->

                  <td [ngStyle]="getRowStyle(item)"
                    *ngIf="(checkAuthority=='MANAGER_AND_HR'|| checkAuthority=='HOD_AND_HR'||checkAuthority =='HOD_AND_MANAGER_AND_HR')&& !(loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD')">
                    <span class="status-badge" [ngClass]="item?.approvalStatus">
                      {{ item?.approvalStatus === 'APPROVED' ? 'Accept' : item?.approvalStatus === 'REJECTED' ? 'Reject'
                      : 'Pending' }}
                    </span>


                  </td>

                  <td *ngIf="isAdminRole(loggedInUserRole)" [ngStyle]="getRowStyle(item)">

                    <button class="pill-btn " [ngClass]="{ 'accept': item.approvalStatus === 'APPROVED' }"
                      (click)="item.approvalStatus = 'APPROVED'; updatedData(item)" [disabled]="isActionDisabled(item)">
                      Accept
                    </button>

                    <button class="pill-btn " [ngClass]="{ 'reject': item.approvalStatus === 'REJECTED' }"
                      (click)="item.approvalStatus = 'REJECTED'; updatedData(item)" [disabled]="isActionDisabled(item)">
                      Reject
                    </button>

                    <input type="hidden" [(ngModel)]="item.approvalStatus" />
                  </td>
                  <td [ngStyle]="getRowStyle(item)">
                    <mat-icon style="width: 36px; margin-bottom: 5px; color: rgb(83, 81, 81);"
                      (click)="onEdit(item,'info')">
                      info
                    </mat-icon>

                  </td>
                  <td [ngStyle]="getRowStyle(item)">
                    <mat-icon style="width: 36px;margin-bottom: 5px;color: rgb(83, 81, 81);" (click)="noDueForm(item)"
                      *ngIf="!item.withdrawalAccepted">description</mat-icon>

                  </td>

                  <!-- Inside your table -->
                  <td *ngIf="['HR Admin', 'Super Admin', 'MD', 'PHI Admin'].includes(loggedInUserRole) "
                    [ngStyle]="getRowStyle(item)">
                    <div class="relieving-cell" *ngIf="!item.withdrawalAccepted"
                      style="display: flex; align-items: center; gap: 10px; position: relative;" [ngStyle]="{ 'background-color': item.mailSend ? '#d4edda' : 'transparent' }">

                      <!-- 👁 View Letter Icon / Spinner -->
                      <span
                        style="position: relative; width: 36px; height: 36px; display: inline-block;margin-top: 10px">
                        <mat-icon *ngIf="!item.isViewLetter" matTooltip="View Letter"
                          [ngClass]="{'disabled-icon': item.verificationStatus !== 'Verified' || item.sendRelievingLetter !== 'Yes'||item.withdrawalAccepted==false||item.approvalStatus == 'REJECTED'}"
                          style="width: 36px; cursor: pointer;" (click)="viewLetter(item, 'view')">
                          visibility
                        </mat-icon>

                        <mat-spinner *ngIf="item.isViewLetter" diameter="21"
                          style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                        </mat-spinner>
                      </span>

                      <!-- 📤 Send Experience Letter Icon / Spinner -->
                      <span class="offer-action-wrapper"
                        style="position: relative; display: inline-block; width: 36px; height: 36px;">

                        <!-- Disabled overlay (if not allowed) -->
                        <div
                          *ngIf="(item.verificationStatus !== 'Verified' || item.sendRelievingLetter !== 'Yes') && !item.isSendingLetter"
                          class="disabled-overlay">
                        </div>

                        <!-- Icon -->

                        <mat-icon *ngIf="!item.isSendingLetter" matTooltip="Send Experience Letter"
                          (click)="(item.verificationStatus === 'Verified' && item.sendRelievingLetter === 'Yes') ? viewLetter(item, 'send') : null"
                          class="info-bordered-icon cp phi-align-content-center"
                          [ngClass]="{'disabled-icon': item.verificationStatus !== 'Verified' || item.sendRelievingLetter !== 'Yes' ||item.fileName==null||item.withdrawalAccepted==false||item.approvalStatus !== 'APPROVED'||item.mailSend}">
                          send
                        </mat-icon>

                        <!-- Spinner -->
                        <mat-spinner *ngIf="item.isSendingLetter" diameter="21"
                          style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                        </mat-spinner>
                      </span>
                    </div>
                  </td>



                  <td [ngStyle]="getRowStyle(item)">

                    <button class="status_withdrwal"
                      [ngClass]="{ 'withdrwal': item.withdrawalReason !== null ,'withdrwalAccepted':item.withdrawalAccepted,'withdrwalRejected':item.withdrawalAccepted==false  }"
                      (click)="withDraw(item,['HR Admin', 'Admin', 'Super Admin', 'PHI Admin', 'MD'].includes(loggedInUserRole)?'hradmin':selectedTypeTabName)">

                      {{item.withdrawalAccepted==true?'Withdrawal':item.withdrawalAccepted==false?'Rejected':'Pending'}}
                    </button>

                  </td>


                  <td
                    *ngIf="selectedTypeTabName !== 'teamResigntion'&& selectedTypeTabName!=='deptResigntion' &&!(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')"
                    [ngStyle]="getRowStyle(item)"
                    [style.opacity]="(item?.approvalStatus!= 'PENDING'||item.withdrawalReason !== null ) ?'0.5' : '1'">
                    <img src="./assets/icon/edit.png" class="cp" (click)="onEdit(item,'edit')"
                      [style.pointer-events]="(item?.approvalStatus!= 'PENDING' ||item.withdrawalReason !== null ) ? 'none' : 'auto'">
                    <!-- <button class="edit-btn" (click)="onEdit(item)">Edit</button> -->
                  </td>


                </tr>
              </tbody>
            </table>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>











  <!-- -----------------------------------------------------HR--------------------------------------------------------------------- -->
  <div>
    <ion-row>
        <ion-col size="12"
        *ngIf="selectedTypeTabName=='termination'&&(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')&& getTabName !=='ExitReport'">

        <button type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content mr-5"
          [disabled]="chechsetupStatus" [ngStyle]="{'opacity':chechsetupStatus?'0.6':'1'}"
          [style.background-color]="buttonColorName" (click)="employeeTermintion(null,null)">
          <span class="material-icons fs-20 mr-5">add</span>Add Termination</button>
      </ion-col>
    </ion-row>
  </div>
  <!-- (loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD') && -->
  <div class="cardBox m-20 p-10" *ngIf="selectedTypeTabName=='termination'&&getTabName !=='ExitReport'">


    <ion-row>
      <ion-col size>
        <mat-form-field class="mat-height40 mat-input-style">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" placeholder="Search" [(ngModel)]="searchTermTerminated"
            (input)="filterEmployeeTerminated()">
        </mat-form-field>
      </ion-col>


      <ion-col size="auto">
        <div class="phi-flex-wrap-center phi-gap-12">
          <label class="phi-flex phi-gap-6 phi-align-items-center">
            <ion-label class="fs-14 fs_12ForMobile font_regular black_color">Show</ion-label>
            <mat-form-field class="w70px mat-height40 mat-input-style">
              <mat-select placeholder="Select" placeholder="Select"
                (selectionChange)="DislaySelectedRecordTermination($event)" [value]="25">
                <mat-option [value]="2">2</mat-option>
                <mat-option [value]="25">25</mat-option>
                <mat-option [value]="50">50</mat-option>
                <mat-option [value]="75">75</mat-option>
                <mat-option [value]="100">100</mat-option>
              </mat-select>
            </mat-form-field>
            <ion-label class="fs-14 fs_12ForMobile font_regular black_color">entries</ion-label>
          </label>

          <div>
            <span class="icon-download fs-20 material-icons" (click)="exportTerminationToCSV()">download</span>
          </div>
        </div>
      </ion-col>


      <!-- <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
        <div class="d-flex justify-content-flex-end ">
        </div>
      </ion-col> -->

    </ion-row>


    <div class="pt-10">
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="table-container">
            <table>
              <thead>
                <tr>

                  <th *ngFor="let item of terminationTableHeader" class="fs-14 fs_12ForMobile font_bold cl-black"
                    [ngStyle]="{ 'max-width': item.maxWidth }">
                    <div class="p-5 icon-style" [innerHTML]="item.label"></div>
                  </th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of terminationEmployeeList ;let i=index">
                  <td>
                    {{i+1}}
                  </td>
                  <td>
                    {{item.empName}}
                  </td>
                  <td>
                    {{item.empBand}}
                  </td>
                  <td>
                    {{item.empGrade}}
                  </td>
                  <td>
                    {{item.empDepartment}}
                  </td>
                  <td>
                    {{item.empDesignation}}
                  </td>
                  <td>
                    {{item.dateOfTermination}}
                  </td>
                  <td>
                    {{ item.lastWorkingDay }}

                  </td>
                  <td>
                    {{ item.personalMailId }}

                  </td>
                  <td>
                    <!-- {{item.terminationReason}} -->
                    <textarea rows="3" cols="32" class="edittextarea" [(ngModel)]="item.terminationReason"
                      maxlength="255" [ngModelOptions]="{standalone: true}" readonly></textarea>
                  </td>
                  <!-- <td>
                    <span class="status-revoke"
                      [ngClass]="{ 'bg-red': !item?.revolveStatus ,'bg-green': item?.revolveStatus }"
                      (click)="updateTermination(item)">
                      Revoke
                    </span>
                  </td> -->



                  <td>
                    <mat-icon style="width: 36px;margin-bottom: 5px;" (click)="noDueForm(item)"
                      *ngIf="!item?.revolveStatus">description</mat-icon>

                  </td>

                  <!-- Inside your table -->
                  <td *ngIf="['HR Admin', 'Super Admin', 'MD', 'PHI Admin'].includes(loggedInUserRole) "
                  >
                    <div class="relieving-cell" *ngIf="!item?.revolveStatus"  [ngStyle]="{ 'background-color': item.mailSend ? '#d4edda' : 'transparent' }"
                      style="display: flex; align-items: center; gap: 10px; position: relative;">

                      <!-- 👁 View Letter Icon / Spinner -->
                      <span
                        style="position: relative; width: 36px; height: 36px; display: inline-block;margin-top: 10px">
                        <mat-icon *ngIf="!item.isViewLetter" matTooltip="View Letter"
                          [ngClass]="{'disabled-icon': item.verificationStatus !== 'Verified' || item.sendRelievingLetter !== 'Yes'}"
                          style="width: 36px; cursor: pointer;" (click)="viewterminationLetter(item, 'view')">
                          visibility
                        </mat-icon>

                        <mat-spinner *ngIf="item.isViewLetter" diameter="21"
                          style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                        </mat-spinner>
                      </span>

                      <!-- 📤 Send Experience Letter Icon / Spinner -->
                      <span class="offer-action-wrapper"
                        style="position: relative; display: inline-block; width: 36px; height: 36px;">

                        <!-- Disabled overlay (if not allowed) -->
                        <div *ngIf="(item.verificationStatus !== 'Verified' || item.sendRelievingLetter !== 'Yes')"
                          class="disabled-overlay">
                        </div>

                        <!-- Icon -->
                        <mat-icon *ngIf="!item.isSendingLetter" matTooltip="Send Letter"
                          (click)="(item.verificationStatus === 'Verified' && item.sendRelievingLetter === 'Yes') ? viewterminationLetter(item, 'send') : null"
                          class="info-bordered-icon cp phi-align-content-center"
                          [ngClass]="{'disabled-icon': item.verificationStatus !== 'Verified' || item.sendRelievingLetter !== 'Yes' ||item.fileName==null||item.mailSend}">
                          send
                        </mat-icon>

                        <!-- Spinner -->
                        <mat-spinner *ngIf="item.isSendingLetter" diameter="21"
                          style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                        </mat-spinner>
                      </span>
                    </div>
                  </td>










                  <td>
                    <span class="status-revoke"
                      [ngClass]="{ 'bg-red': !item?.revolveStatus, 'bg-green': item?.revolveStatus, 'disabled-class': item?.revolveStatus }"
                      (click)="!item?.revolveStatus&&['HR Admin', 'Admin', 'Super Admin', 'PHI Admin', 'MD'].includes(loggedInUserRole)
 && updateTermination(item)">
                      Revoke
                    </span>
                  </td>

                  <td [style.opacity]="item?.revolveStatus ? '0.5' : '1'"
                    *ngIf="!['HOD', 'Manager', 'Employee','Finance'].includes(loggedInUserRole)">
                    <img src="./assets/icon/edit.png" class="cp"
                      [style.pointer-events]="item?.revolveStatus ? 'none' : 'auto'"
                      (click)="onEdittermination(item,'hr')">
                  </td>

                </tr>
              </tbody>
            </table>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>


  <!-- ------------------------------------------------------------------------------Exit Report --------------------------------------------- -->

  <div class="cardBox m-20 p-10" *ngIf="getTabName=='ExitReport' && selectedTypeTabName!=='termination'">


    <ion-row>
      <ion-col size>
        <mat-form-field class="mat-height40 mat-input-style">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">

        </mat-form-field>
      </ion-col>
      <ion-col size="auto">
        <div class="phi-flex-wrap-center phi-gap-12">
          <label class="phi-flex phi-gap-6 phi-align-items-center">
            <ion-label class="fs-14 fs_12ForMobile font_regular black_color">Show</ion-label>
            <mat-form-field class="w70px mat-height40 mat-input-style">
              <mat-select placeholder="Select" placeholder="Select" (selectionChange)="DislaySelectedRecord($event)"
                [value]="25">
                <mat-option [value]="2">2</mat-option>
                <mat-option [value]="25">25</mat-option>
                <mat-option [value]="50">50</mat-option>
                <mat-option [value]="75">75</mat-option>
                <mat-option [value]="100">100</mat-option>
              </mat-select>
            </mat-form-field>
            <ion-label class="fs-14 fs_12ForMobile font_regular black_color">entries</ion-label>
          </label>
          <div>
            <span class="icon-download fs-20 material-icons" (click)="exportToCSV()">download</span>
          </div>
        </div>
      </ion-col>


      <!-- <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
        <div class="d-flex justify-content-flex-end ">
          <div class="d-flex" style="margin-right: 15px; margin-top: 10px;">
            <span class="ml-5 mr-5 icon-download fs-20 material-icons" (click)="exportToCSV()">download</span>
          </div>
        </div>
      </ion-col> -->
    </ion-row>

    <div class="pt-10">
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="table-container">
            <table>
              <thead>
                <tr>

                  <th *ngFor="let item of OfferAndAppointmentTableHeader"
                    class="fs-14 fs_12ForMobile font_bold cl-black" [ngStyle]="{ 'max-width': item.maxWidth }">
                    <div class="p-5 icon-style" [innerHTML]="item.label"></div>
                  </th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of listofFromData; let i = index">
                  <td [ngStyle]="getRowStyle(item)">{{ i + 1 }}</td>

                  <td [ngStyle]="getRowStyle(item)">{{ item.empName
                    }}</td>
                  <td [ngStyle]="getRowStyle(item)">{{
                    item.empDepartment }}</td>
                  <td [ngStyle]="getRowStyle(item)">{{ item.empBand
                    }}</td>
                  <td [ngStyle]="getRowStyle(item)">{{ item.empGrade
                    }}</td>
                  <td [ngStyle]="getRowStyle(item)">{{
                    item.empDesignation }}</td>
                  <td [ngStyle]="getRowStyle(item)">{{
                    item.resignDate }}</td>
                  <td [ngStyle]="getRowStyle(item)">{{
                    item.employmentType }}</td>
                  <td [ngStyle]="getRowStyle(item)">{{
                    item.noticePeriod }}</td>
                  <td [ngStyle]="getRowStyle(item)">{{
                    item.lastWorkingDay | date: 'dd-MM-yyyy' }}</td>
                  <td>
                    {{ item.personalMailId }}

                  </td>
                  <td [ngStyle]="getRowStyle(item)">{{
                    item.resignReason }}</td>
                  <td [ngStyle]="getRowStyle(item)">
                    <!-- {{
                    item.resignReasonInDetails }} -->
                    <textarea rows="3" cols="32" class="edittextarea" [(ngModel)]="item.resignReasonInDetails"
                      maxlength="255" [ngModelOptions]="{ standalone: true }" readonly>
                      </textarea>
                  </td>
                  <td [ngStyle]="getRowStyle(item)">
                    {{
                    item.contactNo }}</td>
                  <td *ngIf="canShowSecretReason()" [ngStyle]="getRowStyle(item)">
                    <!-- {{ item.secretReasonForHr }} -->
                    <textarea rows="3" cols="32" class="edittextarea" [(ngModel)]="item.secretReasonForHr"
                      maxlength="255" [ngModelOptions]="{ standalone: true }" readonly>
                      </textarea>
                  </td>

                  <td *ngIf="canShowManagerCommentSection()" [ngStyle]="getRowStyle(item)">
                    <textarea rows="3" cols="32" class="edittextarea" [(ngModel)]="item.managerComment" maxlength="255"
                      [ngModelOptions]="{ standalone: true }" (focusout)="handleManagerFocusOut(item)"
                      [readonly]="getTabName=='ExitReport'" [ngStyle]="getRowStyle(item)">
                      </textarea>
                  </td>

                  <td *ngIf="canShowHodCommentSection()" [ngStyle]="getRowStyle(item)">
                    <textarea rows="3" cols="32" class="edittextarea" [(ngModel)]="item.hodComment" maxlength="255"
                      [ngModelOptions]="{ standalone: true }" [readonly]="getTabName=='ExitReport'"
                      [ngStyle]="getRowStyle(item)">
                      </textarea>
                  </td>

                  <td [ngStyle]="getRowStyle(item)">
                    <!-- {{
                    item.hrComment || '-' }} -->
                    <textarea rows="3" cols="32" class="edittextarea"
                      (focusout)="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD' && item.terminationFormId == null &&item.withdrawalReason== null) ? updatedData(item) : null"
                      [(ngModel)]="item.hrComment" maxlength="255" [ngModelOptions]="{standalone: true}"
                      [readonly]="getTabName=='ExitReport'"></textarea>
                  </td>
                  <td *ngIf="showTd" [ngStyle]="getRowStyle(item)">


                    <button class="status-btn" [ngClass]="{ 'yes': item.regretType === 'Yes' }"
                      [disabled]="item.terminationFormId != null ||item.withdrawalReason !== null||item?.approvalStatus!= 'PENDING' ">
                      Yes



                    </button>

                    <button class="status-btn" [ngClass]="{ 'no': item.regretType === 'No' }"
                      [disabled]="item.terminationFormId != null ||item.withdrawalReason !== null||item?.approvalStatus!= 'PENDING' ">
                      No
                    </button>

                    <input type="hidden" [(ngModel)]="item.regretType" />

                  </td>
                  <td *ngIf="excludedRoles.includes(loggedInUserRole)" [ngStyle]="getRowStyle(item)">
                    <button class="status-btn" [ngClass]="{ 
      'yes': item.regretType === 'Yes', 
      'no': item.regretType === 'No' 
    }" *ngIf="item.regretType!==null && item.regretType!==''">
                      {{ item.regretType }}
                    </button>


                  </td>
                  <!-- </mat-form-field> -->

                  <td [ngStyle]="getRowStyle(item)"
                    *ngIf="(checkAuthority=='MANAGER_AND_HR'|| checkAuthority=='HOD_AND_HR'||checkAuthority =='HOD_AND_MANAGER_AND_HR')&& !(loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD')">
                    <span class="status-badge" [ngClass]="item?.approvalStatus">
                      {{ item?.approvalStatus === 'APPROVED' ? 'Accept' : item?.approvalStatus === 'REJECTED' ? 'Reject'
                      : 'Pending' }}
                    </span>


                  </td>

                  <td *ngIf="isAdminRole(loggedInUserRole)" [ngStyle]="getRowStyle(item)">

                    <button class="pill-btn " [ngClass]="{ 'accept': item.approvalStatus === 'APPROVED' }"
                      [disabled]="isActionDisabled(item)">
                      Accept
                    </button>

                    <button class="pill-btn " [ngClass]="{ 'reject': item.approvalStatus === 'REJECTED' }"
                      [disabled]="isActionDisabled(item)">
                      Reject
                    </button>

                    <input type="hidden" [(ngModel)]="item.approvalStatus" />
                  </td>




                  <!-- <td [ngStyle]="getRowStyle(item)">

                    <button class="status_withdrwal" [ngClass]="{ 'withdrwal': item.withdrawalReason !== null }">
                      Withdrawal
                    </button>

                  </td> -->
                  <td [ngStyle]="getRowStyle(item)">
                    <mat-icon style="width: 36px; margin-bottom: 5px; color: rgb(83, 81, 81);"
                      (click)="onEdit(item,'info')">
                      info
                    </mat-icon>

                  </td>
                  <td [ngStyle]="getRowStyle(item)">
                    <mat-icon style="width: 36px;margin-bottom: 5px;color: rgb(83, 81, 81);" (click)="noDueForm(item)"
                      *ngIf="!item.withdrawalAccepted">description</mat-icon>

                  </td>

                  <!-- Inside your table -->
                  <td *ngIf="['HR Admin', 'Super Admin', 'MD', 'PHI Admin'].includes(loggedInUserRole) "
                    [ngStyle]="getRowStyle(item)">
                    <div class="relieving-cell" *ngIf="!item.withdrawalAccepted"
                      style="display: flex; align-items: center; gap: 10px; position: relative;">



                      <!-- 📤 Send Experience Letter Icon / Spinner -->


                      {{ item.mailSend ? 'Sent' : 'Not Sent' }}



                    </div>
                  </td>



                  <td [ngStyle]="getRowStyle(item)">

                    <button class="status_withdrwal"
                      [ngClass]="{ 'withdrwal': item.withdrawalReason !== null ,'withdrwalAccepted':item.withdrawalAccepted }"
                      (click)="withDraw(item,['HR Admin', 'Admin', 'Super Admin', 'PHI Admin', 'MD'].includes(loggedInUserRole)?'hradmin':selectedTypeTabName)">

                      {{item.withdrawalAccepted?'Withdrawal':'Pending'}}
                    </button>

                  </td>

                  <!-- <td
                    *ngIf="selectedTypeTabName !== 'teamResigntion'&& selectedTypeTabName!=='deptResigntion' &&!(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')"
                    [ngStyle]="getRowStyle(item)" [style.opacity]="(item?.approvalStatus!= 'PENDING') ?'0.5' : '1'">
                    <img src="./assets/icon/edit.png" class="cp" (click)="onEdit(item)"
                      [style.pointer-events]="(item?.approvalStatus!= 'PENDING') ? 'none' : 'auto'">

                  </td> -->


                </tr>
              </tbody>
            </table>
          </div>
        </ion-col>
      </ion-row>
    </div>

  </div>



  <div *ngIf="getTabName=='ExitReport'">
    <div class="cardBox m-20 p-10"
      *ngIf="selectedTypeTabName=='termination'&&(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">


      <ion-row>
        <ion-col size>
          <mat-form-field class="mat-height40 mat-input-style">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search" [(ngModel)]="searchTermTerminated"
              (input)="filterEmployeeTerminated()">

          </mat-form-field>
        </ion-col>
        <ion-col size="auto">
          <div class="phi-flex-wrap-center phi-gap-12">
            <label class="phi-flex phi-gap-6 phi-align-items-center">
              <ion-label class="fs-14 fs_12ForMobile font_regular black_color">Show</ion-label>
              <mat-form-field class="w70px mat-height40 mat-input-style">
                <mat-select placeholder="Select" placeholder="Select"
                  (selectionChange)="DislaySelectedRecordTermination($event)" [value]="25">
                  <mat-option [value]="2">2</mat-option>
                  <mat-option [value]="25">25</mat-option>
                  <mat-option [value]="50">50</mat-option>
                  <mat-option [value]="75">75</mat-option>
                  <mat-option [value]="100">100</mat-option>
                </mat-select>
              </mat-form-field>
              <ion-label class="fs-14 fs_12ForMobile font_regular pl-10 black_color">entries</ion-label>
            </label>
            <div>
              <span class="icon-download fs-20 material-icons" (click)="exportTerminationToCSV()">download</span>
            </div>
          </div>
        </ion-col>


        <!-- <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
          <div class="d-flex justify-content-flex-end ">
            <div class="d-flex" style="margin-right: 15px; margin-top: 10px;">
              <span class="ml-5 mr-5 icon-download fs-20 material-icons"
                (click)="exportTerminationToCSV()">download</span>
            </div>
          </div>
        </ion-col> -->
      </ion-row>


      <div class="pt-10">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="table-container">
              <table>
                <thead>
                  <tr>

                    <th *ngFor="let item of terminationTableHeader" class="fs-14 fs_12ForMobile font_bold cl-black"
                      [ngStyle]="{ 'max-width': item.maxWidth }">
                      <div class="p-5 icon-style" [innerHTML]="item.label"></div>
                    </th>

                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let item of terminationEmployeeList ;let i=index">
                    <td>
                      {{i+1}}
                    </td>
                    <td>
                      {{item.empName}}
                    </td>
                    <td>
                      {{item.empBand}}
                    </td>
                    <td>
                      {{item.empGrade}}
                    </td>
                    <td>
                      {{item.empDepartment}}
                    </td>
                    <td>
                      {{item.empDesignation}}
                    </td>
                    <td>
                      {{item.dateOfTermination}}
                    </td>
                    <td>
                      {{item.lastWorkingDay}}
                    </td>
                    <td>
                      {{ item.personalMailId }}

                    </td>
                    <td>
                      <!-- {{item.terminationReason}} -->
                      <textarea rows="3" cols="32" class="edittextarea" [(ngModel)]="item.terminationReason"
                        maxlength="255" [ngModelOptions]="{standalone: true}" readonly></textarea>
                    </td>
                    <td>
                      <mat-icon style="width: 36px;margin-bottom: 5px;" (click)="noDueForm(item)"
                        *ngIf="!item?.revolveStatus">description</mat-icon>

                    </td>

                    <!-- Inside your table -->
                    <td *ngIf="['HR Admin', 'Super Admin', 'MD', 'PHI Admin'].includes(loggedInUserRole) ">
                      <div class="relieving-cell" *ngIf="!item?.revolveStatus"
                        style="display: flex; align-items: center; gap: 10px; position: relative;">

                        {{ item.mailSend ? 'Sent' : 'Not Sent' }}


                      </div>
                    </td>
                    <td>
                      <span class="status-revoke"
                        [ngClass]="{ 'bg-red': !item?.revolveStatus ,'bg-green': item?.revolveStatus }">
                        Revoke
                      </span>
                    </td>


                  </tr>
                </tbody>
              </table>
            </div>
          </ion-col>
        </ion-row>
      </div>
    </div>
  </div>


</div>